import React from 'react'
import { Helmet } from 'react-helmet'

import xRoyal from '../../assets/icons/x-royal.svg'
import xCelebrity from '../../assets/icons/x-celebrity.svg'
import facebookRoyal from '../../assets/icons/facebook-royal.svg'
import facebookCelebrity from '../../assets/icons/facebook-celebrity.svg'

export default function EQuotePackageSocialMedia(props) {
  const { brandData, captionForSharerLink, imageForSharerLink } = props
  const defaultText = `I’m really excited about this great offer from ${brandData &&
    brandData.name} that my travel advisor found!`
  const brandCode = brandData ? brandData.brand_code : 'D'
  const isCelebrity = brandCode === 'C'

  const facebook_link = `https://www.facebook.com/sharer/sharer.php?u=${
    window.location.href
  }&picture=${imageForSharerLink}&quote=${encodeURI(
    defaultText
  )}&title=${encodeURI(captionForSharerLink)}`

  const twitter_link = `http://twitter.com/share?text=${encodeURI(
    defaultText
  )}&url=${window.location.href}`

  const openLinkOnNewWindow = e => {
    e.preventDefault()
    return window.open(
      e.currentTarget.href,
      e.currentTarget.name,
      'toolbar=0, status=0, width=600, height=400'
    )
  }

  return (
    <>
      <Helmet>
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="I Can't Wait to Sail!" />
        <meta property="og:description" content={defaultText} />
        <meta property="og:image" content={imageForSharerLink} />
      </Helmet>
      <p>Forward to a Friend</p>
      {props.brandData && (
        <div className="equote-preview-package-outline-share-icons">
          <a href={twitter_link} name="Twitter" onClick={openLinkOnNewWindow}>
            <img src={isCelebrity ? xCelebrity : xRoyal} alt="twitter" />
          </a>
          <a href={facebook_link} name="Facebook" onClick={openLinkOnNewWindow}>
            <img
              src={isCelebrity ? facebookCelebrity : facebookRoyal}
              alt="facebook"
            />
          </a>
        </div>
      )}
    </>
  )
}
